import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {adminService} from "src/api/services/admin";
import {Box, Button, Dialog, DialogContent,} from "@mui/material";
import useToast from "src/hooks/useToast";
import "./GlobalCssClient.css";
import AppLoading from "./AppLoading";
import BaseStatusPage from "./components/BaseStatusPage";
import useSystemTheme from "../../hooks/useSystemTheme";

const ClientSide = () => {
    const {toast} = useToast();
    const location = useLocation();
    const parameters = location.pathname.split("/");
    let hash = parameters[parameters.length - 1];
    const [details, setDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const {isDarkMode} = useSystemTheme();
    const [showTerms, setShowTerms] = useState(false);
    const [html, setHtml] = useState({__html: ""});

    const getData = async (isLoadable = true) => {
        try {
            if (isLoadable) setIsLoading(true);
            let res = await adminService.getClientSideInvoice(hash, isDarkMode);
            const data = res.data.data
            setDetails(data);
            setHtml({__html: res.data.data.terms_and_conditions || ""});
            setIsLoading(false);
        } catch (error) {
            toast(error.response.data.message, "error");
            setIsLoading(false);
            if (error.response.data.message === 'this state in not valid for this booking.') {
                window && window.location.reload()
            }
        } finally {
            setIsLoading(false);
        }
    };

    const refreshDataOnRequest = async () => {
        await getData(true)
    }

    const refreshDataOnSubmitFeedback = async () => {
        await getData(true)
    }


    useEffect(() => {
        getData(true);
        setInterval(() => {
            getData(false);
        }, 10000)
    }, []);

    useEffect(() => {
        const bg = isDarkMode ? '#050406' : '#ffffff';
        const root = document.getElementById('root');
        const themeMeta = document.querySelector('meta[name="theme-color"]');
        const prev = {
            html: document.documentElement.style.backgroundColor,
            body: document.body.style.backgroundColor,
            root: root?.style.backgroundColor,
            theme: themeMeta?.getAttribute('content'),
        };
        document.documentElement.style.backgroundColor = bg;
        document.body.style.backgroundColor = bg;
        if (root) root.style.backgroundColor = bg;
        if (themeMeta) themeMeta.setAttribute('content', bg);
        return () => {
            document.documentElement.style.backgroundColor = prev.html;
            document.body.style.backgroundColor = prev.body;
            if (root) root.style.backgroundColor = prev.root;
            if (themeMeta && prev.theme) themeMeta.setAttribute('content', prev.theme);
        };
    }, [isDarkMode]);

    return (
        <>
            <Box
                display="flex"
                justifyContent="center"
                // fontFamily="'Outfit', sans-serif"
                sx={{
                    background: isDarkMode ?
                        "rgba(5, 4, 6, 1)" :
                        'rgba(255, 255, 255, 1)',
                    minHeight: "100vh",
                    position: "relative",
                    fontFamily: 'Outfit, sans-serif !important'
                }}>
                <Box sx={{
                    maxWidth: "600px",
                    paddingX: '20px'
                }}>
                    {isLoading && <AppLoading/>}
                    {(!isLoading && details) && <>
                        <BaseStatusPage
                            details={details}
                            onRequestCar={() => {
                                refreshDataOnRequest()
                            }}
                            onSubmitFeedback={() => {
                                refreshDataOnSubmitFeedback()
                            }}/>
                    </>}
                    {(!isLoading && !details) &&
                        <Box
                            style={{
                                display: "flex",
                                width: "100%",
                                height: "100%",
                                justifyContent: "center",
                                alignContent: "center",
                                alignItems: "center",
                                fontSize: 24,
                            }}
                        >
                            Sorry, this link is not working at the moment!
                        </Box>
                    }
                    <>
                        <Dialog open={showTerms} fullWidth className="ads-dialog">
                            <DialogContent>
                                <Box sx={{direction: "ltr"}}>
                                    <div
                                        style={{direction: "ltr"}}
                                        dangerouslySetInnerHTML={html}
                                    ></div>
                                </Box>
                                <Button
                                    style={{
                                        backgroundColor: "#217AFF",
                                        color: "white",
                                        height: 34,
                                        width: "100%",
                                    }}
                                    onClick={() => setShowTerms(false)}
                                >
                                    {"Close"}
                                </Button>
                            </DialogContent>
                        </Dialog>
                    </>
                </Box>
            </Box>
        </>
    );
};
export default ClientSide;
